import { render, staticRenderFns } from "./LayoutBack.vue?vue&type=template&id=23203034&scoped=true"
import script from "./LayoutBack.vue?vue&type=script&lang=js"
export * from "./LayoutBack.vue?vue&type=script&lang=js"
import style1 from "./LayoutBack.vue?vue&type=style&index=1&id=23203034&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23203034",
  null
  
)

export default component.exports